import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, CanDeactivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import * as UserFactory from '@factories/user.factory';
import { LoginService } from '@services/login.service';
import { ICanDeactivateComponent } from '@interfaces/nebula';

export function adminGuards(): CanActivateFn {
  return (snapshot: ActivatedRouteSnapshot) => {
    const loginService: LoginService = inject(LoginService);
    const router: Router = inject(Router);
    return loginService.getCurrentUser.pipe(
      map(user => {
        if (UserFactory.isAdmin(user) || UserFactory.isUserHasAdminCapabilities(user)) {
          return true;
        }
        void router.navigate(['', 'application', 'home']);

        // some routes have different name as capability
        const include = (snapshot.data.capabilityGroup as string) || snapshot.routeConfig.path;
        return UserFactory.getUserCapabilitiesGroup(user).includes(include);
      })
    );
  };
}

export function canDeactivateGuard(): CanDeactivateFn<ICanDeactivateComponent> {
  return component => {
    if (typeof component?.canDeactivate !== 'function') {
      return Promise.resolve(true);
    }
    return component.canDeactivate();
  };
}
